import { Fieldset } from 'primereact/fieldset'
import React, { useState } from 'react'
import { connect } from 'react-redux'
import { Btn, CustomCheckbox, CustomDropdown } from '../../../../components'
import { showMessageBox } from '../../../../store/actions/system.actions'

function EnvioJustificativaCargaParada({
  onBtnSalvarInfo,
  selectedTp,
  dispatch,
  motivosAtraso,
  onSelecionarTodos,
}) {
  const [motivoAtraso, setMotivoAtraso] = useState(null)
  const [selecionarTodos, setSelelecionarTodos] = useState(false)

  const onBtnSalvarClick = () => {
    if (!motivoAtraso)
      dispatch(showMessageBox(null, 'Se a carga está atrasada, é necesario indicar um motivo'))
    else {
      onBtnSalvarInfo({
        motivo_atraso_id: motivoAtraso.id,
      })
    }
  }

  return (
    <div>
      <Fieldset legend="Selecione a Justificativa para as Cargas Paradas">
        <div className="p-grid p-col-align-center">
          <div className="p-col-fixed" style={{ paddingTop: 30 }}>
            <CustomCheckbox
              checked={selecionarTodos}
              onChange={() => {
                setSelelecionarTodos(!selecionarTodos)
                onSelecionarTodos(!selecionarTodos)
              }}
            >
              Selecionar Todos
            </CustomCheckbox>
          </div>
          <div className="p-col-4" style={{ paddingTop: 0 }}>
            <CustomDropdown
              optionLabel="name"
              options={motivosAtraso}
              value={motivoAtraso}
              label="Justificativa :*"
              filter={true}
              onChange={value => setMotivoAtraso(value)}
            />
          </div>
          <div className="p-col-4" style={{ paddingTop: 27 }}>
            <Btn onClick={onBtnSalvarClick}>Salvar Informações</Btn>
          </div>
        </div>
      </Fieldset>
    </div>
  )
}

export default connect()(EnvioJustificativaCargaParada)
